module.exports = __webpack_public_path__ + "assets/img/th-e59c2311.png";